import { c as _c } from "react/compiler-runtime";
import { gql, useQuery } from '@material-bank/graphql-client';
const VARIANT_AVAILABILITY_QUERY = gql`
  query VariantAvailability($productSku: String!, $locale: String) {
    variantAvailability(productSku: $productSku, locale: $locale) {
      sku
      isOnStock
      availableQuantity
    }
  }
`;
export type VariantAvailability = {
  sku: string;
  isOnStock: boolean;
  availableQuantity: number;
};
type VariantAvailabilityData = {
  variantAvailability: VariantAvailability[];
};
type UseVariantAvailabilityQueryOptions = {
  productSku: string;
  locale?: string;
};

// Stock is the one volatile field on a product, so it is read separately from the
// session-long catalog payload and revalidated on every mount. Keyed on the product
// sku rather than a variant list, so it runs in parallel with the product query and
// resolves out of the same server-side cache entry — no extra upstream traffic.
export function useVariantAvailabilityQuery(t0) {
  const $ = _c(12);
  const {
    productSku,
    locale: t1
  } = t0;
  const locale = t1 === undefined ? "en-US" : t1;
  let t2;
  if ($[0] !== locale || $[1] !== productSku) {
    t2 = {
      productSku,
      locale
    };
    $[0] = locale;
    $[1] = productSku;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !productSku;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = {
      variables: t2,
      skip: t3,
      fetchPolicy: "cache-and-network"
    };
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data,
    loading,
    error
  } = useQuery(VARIANT_AVAILABILITY_QUERY, t4);
  let t5;
  if ($[6] !== data?.variantAvailability) {
    t5 = data?.variantAvailability ?? [];
    $[6] = data?.variantAvailability;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== error || $[9] !== loading || $[10] !== t5) {
    t6 = {
      availability: t5,
      loading,
      error
    };
    $[8] = error;
    $[9] = loading;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}